export const faqFn = () => {
  const faqs = document.querySelectorAll(".faq");

  faqs.forEach((faq) => {
    const faqItemHeight = Number.parseInt(
      faq.getAttribute("data-faq-item-height"),
      10,
    );
    const faqItems = faq.querySelectorAll(".faq__item");

    const getCollapsedHeight = (item) => {
      const header = item.querySelector(".faq__header");

      if (!header) {
        return faqItemHeight;
      }

      return Math.max(faqItemHeight, Math.ceil(header.scrollHeight));
    };

    const setCollapsedHeight = (item) => {
      item.style.height = `${getCollapsedHeight(item)}px`;
    };

    const syncItemHeight = (item) => {
      if (item.classList.contains("opened")) {
        item.style.height = "auto";
        item.style.height = `${item.scrollHeight}px`;
        return;
      }

      setCollapsedHeight(item);
    };

    const toggleFaq = (item, faqItems) => {
      faqItems.forEach((elem) => {
        if (item !== elem) {
          elem.classList.remove("opened");
          setCollapsedHeight(elem);
        }
      });

      if (!item.classList.contains("opened")) {
        const collapsedHeight = getCollapsedHeight(item);

        item.classList.add("opened");
        item.style.height = "auto";

        const height = `${item.scrollHeight}px`;

        item.style.height = `${collapsedHeight}px`;

        setTimeout(() => {
          item.style.height = height;
        }, 0);
      } else {
        setCollapsedHeight(item);

        item.addEventListener(
          "transitionend",
          function () {
            item.classList.remove("opened");
          },
          {
            once: true,
          }
        );
      }
    };

    faqItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        toggleFaq(item, faqItems);
      });
    });

    if (faqItems.length > 0) {
      toggleFaq(faqItems[0], faqItems);
    }

    window.addEventListener("resize", () => {
      faqItems.forEach(syncItemHeight);
    });
  });
};
